export var ClassNames;
(function (ClassNames) {
    /**
     * Concatenate classnames into a single string
     */
    function concat(...args) {
        let classes = [];
        for (const argument of args) {
            if (!argument) {
                continue;
            }
            if (typeof argument === 'string') {
                // if string add to output
                classes.push(argument);
            }
            else if (Array.isArray(argument)) {
                // if array, spread into output
                classes = [...classes, concat(argument)];
            }
            else if (typeof argument === 'object') {
                for (const key in argument) {
                    // if object,
                    if (argument[key]) {
                        classes.push(key);
                    }
                }
            }
        }
        return classes.join(' ');
    }
    ClassNames.concat = concat;
})(ClassNames || (ClassNames = {}));
